import { Box, Button, TextInput } from "@dealer-center/core-components";
import { useAccountSwitcherUiAPIInterfaceNew } from "@dealer-center/ddc-pages-account-switcher-ui-fetch";
import { useMemo, useState } from "react";
import { Outlet, useNavigate, useParams } from "react-router-dom";

export const PagesAccountSwitcherUiUiInputNew = () => {
  const { searchValue: searchValueFromParams } = useParams();
  const [searchValue, setSearchValue] = useState(searchValueFromParams || "");
  const [submittedSearchValue, setSubmittedSearchValue] = useState(
    searchValueFromParams || ""
  );
  const memoizedSearchValue = useMemo(
    () => submittedSearchValue,
    [submittedSearchValue]
  );
  const { isLoading } = useAccountSwitcherUiAPIInterfaceNew({
    searchValue: memoizedSearchValue
  });
  const navigate = useNavigate();
  const submitSearch = () => {
    setSubmittedSearchValue(searchValue);
    navigate(`/accountSwitcherUiNew/${searchValue}`);
  };

  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          gap: 2,
          alignItems: "flex-end"
        }}
      >
        <TextInput
          id="PagesAccountSwitcherUiUiTextInput"
          label="Search"
          name="PagesAccountSwitcherUiUiTextInput"
          placeholder="Enter search value"
          value={searchValue}
          onChange={e => setSearchValue(e.target.value)}
          onKeyDown={e => {
            if (e.key === "Enter") {
              submitSearch();
            }
          }}
        />
        <Button
          analyticsConfiguration={{
            eventName: "PagesAccountSwitcherUiUi Search"
          }}
          buttonStyle="primary"
          disabled={!searchValue}
          isLoading={isLoading}
          onClick={() => submitSearch()}
        >
          Search
        </Button>
      </Box>
      <Outlet />
    </>
  );
};
